import { styled, Button, Typography } from '@mui/material';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from '../../config/firebase';
import clsx from 'clsx';
import { useState } from 'react';

export default function ImageUpload({ children, className, setImageURL, setProgress, setUploading }) {
  const [error, setError] = useState('');

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const uploadHandler = (e) => {
    setError('');
    setUploading(true);

    const file = e.target.files?.[0];
    if (!file) {
      setUploading(false);
      return;
    }

    if (!file.type.startsWith('image/')) {
      setError('Only image files are allowed.');
      setUploading(false);
      return;
    }

    const storageRef = ref(storage, `images/${Date.now()}-${crypto.randomUUID()}-${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
      },
      (error) => {
        setUploading(false);
        console.error('Upload failed:', error);
        setError('Upload failed. Please try again.');
      },
      () => {
        setUploading(false);
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setImageURL(downloadURL);
        });
      }
    );
  };

  return (
    <>
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        className={className}
      >
        {children}
        <VisuallyHiddenInput
          type="file"
          accept="image/*"
          onChange={uploadHandler}
          multiple
        />
      </Button>

      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </>
  );
}
